export class NDCService {
  constructor(axios, apiUrl) {
    this.$axios = axios;
    this.apiUrl = apiUrl;
  }

  /**
   * Get info about NDC offer
   * @param {} data
   * @returns {}
   */
  async getNdcCode(ndcCode) {
    return await this.$axios.get(this.apiUrl + "Offers/NDC/" + ndcCode + "/Offer").then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  async addTouchPoint(ndcCode, isQRCode = false) {

    const isQRCodeParam = new URLSearchParams(window.location.search).get("isQR");

    if (isQRCodeParam) {
      isQRCode = isQRCodeParam;
    }

    // API call to get NDC info
    var touchPoint = await this.$axios.put(this.apiUrl + "Offers/NDC/" + ndcCode + `/TouchPoint?isQR=${isQRCode}`).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });

    if (touchPoint.error) {
      return false;
    }
    else {
      return touchPoint;
    }
  }
}